// // MyEdit.jsx
// import React, { useState, useRef, useEffect } from "react";
// import axios from "axios";
// import useAuthStore from "../../services/authStore";
// import { toastSuccess, toastError, toastWarning } from "../../services/toaster";
// import "./MyEdit.css";
// import { useNavigate, useLocation } from "react-router-dom";
// import { FaChevronDown, FaSpinner } from "react-icons/fa";
// import { Eye } from "lucide-react";

// const API_URL = process.env.REACT_APP_API_URL;

// const emptyRow = {
//   expense_type_id: "",
//   description: "",
//   date: "",
//   amount: "",
//   approved_amount: "",
//   remarks: "",
//   gl_code: "",
//   currency: "",
//   attachment: null,
// };

// export default function MyEdit() {
//   // ================= STORE =================
//   const token = useAuthStore((s) => s.token);
//   const companyId = useAuthStore((s) => s.companyId);
//   const userId = useAuthStore((s) => s.user_id);
//   const currency = useAuthStore((s) => s.currency);
//   const employeeCode = useAuthStore((s) => s.employee_code);

//   const navigate = useNavigate();
//   const location = useLocation(); // ✅ Use location (not locationState)

//   const [attachmentLoading, setAttachmentLoading] = useState({});

//   // ✅ Get where we came from
//   const from = location.state?.from || "requests";
//   const currentStatus = location.state?.currentStatus || "pending";

//   // ================= REFS =================
//   const tableRef = useRef(null);
//   const dropdownRef = useRef(null);
//   const selectRef = useRef(null);

//   // ================= STATE =================
//   const [loading, setLoading] = useState(false);
//   const [expenseTypes, setExpenseTypes] = useState([]);
//   const [lines, setLines] = useState([{ ...emptyRow }]);
//   const [purpose, setPurpose] = useState("");
//   const [description, setDescription] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [openCategoryRow, setOpenCategoryRow] = useState(null);
//   const [categorySearch, setCategorySearch] = useState("");
//   const [expenseId, setExpenseId] = useState(null);
//   const [expenseCode, setExpenseCode] = useState("");
//   const [previewUrl, setPreviewUrl] = useState(null);
//   const [showPreview, setShowPreview] = useState(false);

//   const currencyOptions = ["INR", "USD", "EUR", "AED"];

//   const handleAttachment = async (line, download = false) => {
//     try {
//       const fileName = line.attachment_url?.split("/").pop() || "attachment";
//       const actionKey = `${line.id}-${download ? "download" : "view"}`;

//       setAttachmentLoading((prev) => ({ ...prev, [actionKey]: true }));

//       const res = await axios.get(`${API_URL}/expense/attachment`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           company_id: companyId,
//           master_id: expenseId, // the expense ID

//           expense_code: expenseCode, // you need to store this in state
//           file_name: fileName,
//           download: download,
//         },
//         responseType: "blob",
//       });

//       const fileURL = window.URL.createObjectURL(res.data);

//       if (!download) {
//         setPreviewUrl(fileURL);
//         setShowPreview(true);
//         return;
//       }

//       // download logic (optional)
//       const link = document.createElement("a");
//       link.href = fileURL;
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//     } catch (err) {
//       toastError("Failed to load attachment");
//     } finally {
//       const actionKey = `${line.id}-${download ? "download" : "view"}`;
//       setAttachmentLoading((prev) => ({ ...prev, [actionKey]: false }));
//     }
//   };

//   const handlePreview = (url) => {
//     setPreviewUrl(url);
//     setShowPreview(true);
//   };

//   // ================= CLICK OUTSIDE HANDLER =================
//   useEffect(() => {
//     const handleClickOutside = () => {
//       setOpenCategoryRow(null);
//       setCategorySearch("");
//     };

//     document.addEventListener("click", handleClickOutside);

//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, []);

//   // ================= FETCH EXPENSE TYPES =================
//   useEffect(() => {
//     if (!companyId || !token) return;

//     fetch(`${API_URL}/expense-type/${companyId}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         const list = Array.isArray(data) ? data : data?.data || [];
//         const activeExpenseTypes = list.filter(
//           (item) => Number(item.isactive) === 1,
//         );
//         setExpenseTypes(activeExpenseTypes);
//       })
//       .catch(console.error);
//   }, [companyId, token]);

//   // ================= LOAD EXPENSE DATA FOR EDIT =================
//   useEffect(() => {
//     console.log("📍 Location state:", location.state);

//     if (location.state?.expenseData) {
//       const expenseData = location.state.expenseData;
//       console.log("📦 Expense data received:", expenseData);

//       setExpenseId(expenseData.id);
//       setExpenseCode(expenseData.expense_id);
//       setPurpose(expenseData.purpose || "");
//       setDescription(expenseData.description || "");

//       // Map expense lines
//       if (expenseData.expense_lines && expenseData.expense_lines.length > 0) {
//         const mappedLines = expenseData.expense_lines.map((line) => ({
//           id: line.id,
//           expense_type_id: line.expense_type_id || "",
//           description: line.description || "",
//           date: line.date || "",
//           amount: line.total_amount || "",
//           approved_amount:
//             line.approved_amount && Number(line.approved_amount) > 0
//               ? line.approved_amount
//               : line.total_amount,
//           remarks: line.remarks || "",
//           gl_code: line.gl_code || "",
//           currency: line.currency || "INR",
//           attachment: null,
//           attachment_url: line.attachment || null,
//         }));
//         console.log("📝 Mapped lines:", mappedLines);
//         setLines(mappedLines);
//       } else {
//         setLines([{ ...emptyRow }]);
//       }
//     } else {
//       console.warn("⚠️ No expense data found in location.state");
//       setLines([{ ...emptyRow }]);
//     }
//   }, [location.state]);

//   // ================= HELPERS =================
//   const addAmounts = (amounts = []) => {
//     let totalPaise = 0;
//     amounts.forEach((value) => {
//       const clean = String(value || "0").replace(/,/g, "");
//       const [rupees = "0", decimals = "00"] = clean.split(".");
//       const decimalValue = (decimals + "00").slice(0, 2);
//       totalPaise += Number(rupees) * 100 + Number(decimalValue);
//     });
//     return (totalPaise / 100).toFixed(2);
//   };

//   const formatIndianNumber = (value) => {
//     if (!value) return "";
//     const [integerPart, decimalPart] = String(value).split(".");
//     const lastThree = integerPart.slice(-3);
//     const otherNumbers = integerPart.slice(0, -3);
//     const formattedInteger =
//       otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
//       (otherNumbers ? "," : "") +
//       lastThree;
//     return decimalPart !== undefined
//       ? `${formattedInteger}.${decimalPart}`
//       : formattedInteger;
//   };

//   const formatInternationalNumber = (value) => {
//     if (!value) return "";
//     const [integerPart, decimalPart] = String(value).split(".");
//     const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//     return decimalPart !== undefined
//       ? `${formattedInteger}.${decimalPart}`
//       : formattedInteger;
//   };

//   const formatAmount = (amount, currencyCode = "INR") => {
//     const value = String(amount || "0").replace(/,/g, "");
//     if (currencyCode === "INR") {
//       return formatIndianNumber(Number(value).toFixed(2));
//     }
//     return formatInternationalNumber(Number(value).toFixed(2));
//   };

//   const formatInputAmount = (amount, currency) => {
//     if (!amount) return "";
//     const clean = String(amount).replace(/,/g, "");
//     if (currency === "INR") return formatIndianNumber(clean);
//     return formatInternationalNumber(clean);
//   };

//   const getFileExtension = (filename) =>
//     filename.split(".").pop().toLowerCase();

//   const allowed_extensions = ["png", "jpg", "jpeg", "pdf", "xlsx", "xls"];

//   const fileToBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => {
//         const base64 = reader.result.split(",")[1];
//         resolve({
//           filename: file.name,
//           base64: base64,
//         });
//       };
//       reader.onerror = (err) => reject(err);
//     });
//   };

//   // ================= GROUP BY CURRENCY =================
//   const groupedByCurrency = lines.reduce((acc, line, originalIndex) => {
//     const cur = line.currency || "INR";
//     if (!acc[cur]) acc[cur] = [];
//     acc[cur].push({ ...line, originalIndex });
//     return acc;
//   }, {});

//   // ================= UPDATE LINE =================
//   const updateLine = (i, field, value) => {
//     setLines((prev) =>
//       prev.map((l, index) => (index === i ? { ...l, [field]: value } : l)),
//     );
//   };

//   // ================= VALIDATION =================
//   const validateForm = () => {
//     if (!purpose.trim()) {
//       toastWarning("Please enter purpose");
//       return false;
//     }
//     if (lines.length === 0) {
//       toastWarning("Please add at least one expense line");
//       return false;
//     }
//     for (let i = 0; i < lines.length; i++) {
//       const line = lines[i];
//       if (!line.expense_type_id) {
//         toastError(`Row ${i + 1}: Please select a category`);
//         return false;
//       }
//       if (!line.description) {
//         toastWarning(`Row ${i + 1}: Please enter a description`);
//         return false;
//       }
//       if (!line.amount || Number(line.amount) <= 0) {
//         toastWarning(`Row ${i + 1}: Please enter a valid amount`);
//         return false;
//       }

//       const expenseAmount = parseFloat(line.amount || 0);
//       const approvedAmount = parseFloat(line.approved_amount || 0);

//       if (approvedAmount < expenseAmount && line.remarks.trim() === "") {
//         toastError(`Row ${i + 1}: Approved Remark is required `);
//         return false;
//       }

//       if (!line.date) {
//         toastWarning(`Row ${i + 1}: Please select a date`);
//         return false;
//       }
//     }
//     return true;
//   };

//   console.log("expenseId =", expenseId);

//   // ================= HANDLE SUBMIT =================
//   const handleSubmit = async () => {
//     if (!validateForm()) return;
//     setIsSubmitting(true);

//     try {
//       const convertedAttachments = await Promise.all(
//         lines.map(async (line) => {
//           if (!line.attachment) return null;
//           return await fileToBase64(line.attachment);
//         }),
//       );

//       let response;

//       if (expenseId) {
//         const approvedPayload = {
//           expense_id: Number(expenseId),
//           user_id: Number(userId),
//           expense_lines: lines.map((line) => ({
//             id: Number(line.id),
//             expense_type_id: Number(line.expense_type_id),
//             currency: line.currency,
//             approved_amount: Number(
//               String(line.approved_amount || 0).replace(/,/g, ""),
//             ),
//             remarks: line.remarks || "",
//           })),
//         };

//         response = await axios.put(
//           `${API_URL}/expense/approved-amount`,
//           approvedPayload,
//           {
//             params: {
//               company_id: companyId,
//             },
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           },
//         );

//         // toastSuccess("Approved amount updated successfully!");
//       } else {
//         const payload = {
//           company_id: String(companyId),
//           user_id: String(userId),
//           employee_code: employeeCode || String(userId),
//           purpose: purpose,
//           currency: currency || "INR",
//           total_amount: Number(addAmounts(lines.map((l) => l.amount))),
//           description: description,
//           attachment: null,
//           expense_lines: lines.map((l, index) => ({
//             expense_type_id: Number(l.expense_type_id),
//             description: l.description,
//             date: l.date,
//             currency: l.currency,
//             total_amount: Number(addAmounts([l.amount])),
//             attachment: convertedAttachments[index] || null,
//             approved_amount: l.approved_amount ? Number(l.approved_amount) : 0,
//             remarks: l.remarks || "",
//           })),
//         };

//         response = await axios.post(
//           `${API_URL}/expense/${companyId}`,
//           payload,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           },
//         );

//         toastSuccess("Expense created successfully!");
//       }

//       const expenseIdToPass = expenseId || response?.data?.data?.id;

//       // ✅ Navigate back to where we came from
//       if (from === "authorisations") {
//         navigate(`/authorisations/${currentStatus}`, {
//           state: {
//             selectedExpenseId: expenseIdToPass,
//           },
//         });
//       } else {
//         navigate(`/requests/${currentStatus}`, {
//           state: {
//             selectedExpenseId: expenseIdToPass,
//           },
//         });
//       }
//     } catch (error) {
//       console.error("❌ Error:", error);
//       if (error.response) {
//         console.error("Response data:", error.response.data);
//         toastError(
//           error.response.data?.message ||
//             error.response.data?.error ||
//             `Server error: ${error.response.status}`,
//         );
//       } else if (error.request) {
//         toastError("Network error. Please check your connection.");
//       } else {
//         toastError(error.message || "Something went wrong");
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // ================= HANDLE CANCEL =================
//   const handleCancel = () => {
//     // ✅ Navigate back to where we came from
//     if (from === "authorisations") {
//       navigate(`/authorisations/${currentStatus}`);
//     } else {
//       navigate(`/requests/${currentStatus}`);
//     }
//   };

//   // ================= LOADING STATE =================
//   if (loading) {
//     return (
//       <div className="center-loader">
//         <FaSpinner className="spinner" />
//         <div>Loading...</div>
//       </div>
//     );
//   }

//   // ================= RENDER =================
//   return (
//     <div className="edit-main-wrapper">
//       <div className="edit-top-fixed">
//         <div className="edit-purpose-wrapper">
//           <label className="edit-purpose-label">
//             Purpose <span className="edit-required-star">*</span>
//           </label>
//           <input
//             type="text"
//             className="edit-purpose-input"
//             value={purpose}
//             disabled
//           />
//         </div>

//         <div className="edit-line-header-wrapper">
//           <h3 className="edit-line-title">Expense Line Items</h3>
//         </div>
//       </div>

//       <div className="edit-table-scroll" ref={tableRef}>
//         <table className="edit-data-table">
//           <thead>
//             <tr>
//               <th className="edit-th-serial">#</th>
//               <th className="edit-th-category">Expense Category</th>
//               <th className="edit-th-currency">Currency</th>
//               <th className="edit-th-description">Expense Description</th>
//               <th className="edit-th-date">Expense Date</th>
//               <th className="edit-th-amount">Expense Amount</th>
//               <th className="edit-th-approved-amount">Approved Amount</th>
//               <th className="edit-th-remarks">Aprroved Remark</th>
//               <th className="edit-th-attachment">Attachment</th>
//             </tr>
//           </thead>

//           <tbody>
//             {Object.entries(groupedByCurrency).map(([currency, items]) => {
//               const total = addAmounts(items.map((item) => item.amount));
//               return (
//                 <React.Fragment key={currency}>
//                   {items.map((line) => {
//                     const rowIndex = line.originalIndex;
//                     return (
//                       <tr key={rowIndex} className="edit-data-row">
//                         <td className="edit-td-serial">{rowIndex + 1}</td>

//                         {/* CATEGORY */}
//                         <td
//                           className="edit-td-category"
//                           style={{ position: "relative" }}
//                         >
//                           <div
//                             className="edit-custom-select-box"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setOpenCategoryRow(
//                                 openCategoryRow === rowIndex ? null : rowIndex,
//                               );
//                             }}
//                           >
//                             <span className="edit-selected-category-text">
//                               {expenseTypes.find(
//                                 (t) =>
//                                   String(t.id) === String(line.expense_type_id),
//                               )?.expensetypename || "Select Expense Category"}
//                             </span>
//                             <FaChevronDown
//                               className={`edit-dropdown-arrow ${
//                                 openCategoryRow === rowIndex
//                                   ? "edit-rotate"
//                                   : ""
//                               }`}
//                             />
//                           </div>

//                           {openCategoryRow === rowIndex && (
//                             <div
//                               ref={dropdownRef}
//                               className="edit-custom-dropdown"
//                               onClick={(e) => e.stopPropagation()}
//                             >
//                               <div className="edit-dropdown-search-wrapper">
//                                 <input
//                                   autoFocus
//                                   type="text"
//                                   className="edit-dropdown-search"
//                                   onClick={(e) => e.stopPropagation()}
//                                   placeholder="Search expense category..."
//                                   value={categorySearch}
//                                   onChange={(e) =>
//                                     setCategorySearch(e.target.value)
//                                   }
//                                 />
//                               </div>
//                               <div className="edit-dropdown-list">
//                                 {expenseTypes
//                                   .filter((item) =>
//                                     item.expensetypename
//                                       .toLowerCase()
//                                       .includes(categorySearch.toLowerCase()),
//                                   )
//                                   .map((item) => (
//                                     <div
//                                       key={item.id}
//                                       className={`edit-dropdown-item ${
//                                         String(line.expense_type_id) ===
//                                         String(item.id)
//                                           ? "edit-selected"
//                                           : ""
//                                       }`}
//                                       onClick={() => {
//                                         updateLine(
//                                           rowIndex,
//                                           "expense_type_id",
//                                           item.id,
//                                         );
//                                         updateLine(
//                                           rowIndex,
//                                           "gl_code",
//                                           item.glcode || "",
//                                         );
//                                         updateLine(
//                                           rowIndex,
//                                           "currency",
//                                           item.currency || "INR",
//                                         );
//                                         setOpenCategoryRow(null);
//                                         setCategorySearch("");
//                                       }}
//                                     >
//                                       {item.expensetypename}
//                                     </div>
//                                   ))}
//                               </div>
//                             </div>
//                           )}
//                         </td>

//                         {/* CURRENCY */}
//                         <td className="edit-td-currency">
//                           <select
//                             className="edit-currency-select"
//                             value={line.currency || ""}
//                             onChange={(e) =>
//                               updateLine(rowIndex, "currency", e.target.value)
//                             }
//                           >
//                             {currencyOptions.map((cur) => (
//                               <option key={cur} value={cur}>
//                                 {cur}
//                               </option>
//                             ))}
//                           </select>
//                         </td>

//                         {/* DESCRIPTION */}
//                         <td className="edit-td-description">
//                           <input
//                             className="edit-description-input"
//                             value={line.description}
//                             placeholder="Enter expense description"
//                             onChange={(e) =>
//                               updateLine(
//                                 rowIndex,
//                                 "description",
//                                 e.target.value,
//                               )
//                             }
//                           />
//                         </td>

//                         {/* DATE */}
//                         <td className="edit-td-date">
//                           <input
//                             className="edit-date-input"
//                             type="date"
//                             value={line.date}
//                             disabled
//                           />
//                         </td>

//                         {/* AMOUNT */}
//                         <td className="edit-td-amount">
//                           <input
//                             type="text"
//                             inputMode="decimal"
//                             placeholder="0.00"
//                             className="edit-amount-input"
//                             value={formatInputAmount(
//                               line.amount,
//                               line.currency,
//                             )}
//                             onChange={(e) => {
//                               let rawValue = e.target.value.replace(/,/g, "");
//                               if (!/^\d*\.?\d{0,2}$/.test(rawValue)) return;
//                               updateLine(rowIndex, "amount", rawValue);
//                             }}
//                             onBlur={() => {
//                               if (line.amount !== "") {
//                                 updateLine(
//                                   rowIndex,
//                                   "amount",
//                                   Number(
//                                     String(line.amount).replace(/,/g, ""),
//                                   ).toFixed(2),
//                                 );
//                               }
//                             }}
//                           />
//                         </td>

//                         {/* APPROVED AMOUNT */}
//                         <td className="edit-td-approved-amount">
//                           <input
//                             type="text"
//                             inputMode="decimal"
//                             className="edit-approved-amount-input"
//                             value={formatInputAmount(
//                               line.approved_amount || "",
//                               line.currency,
//                             )}
//                             onChange={(e) => {
//                               const value = e.target.value.replace(/,/g, "");

//                               if (!/^\d*\.?\d{0,2}$/.test(value)) {
//                                 return;
//                               }

//                               const expenseAmount = Number(
//                                 String(line.amount || 0).replace(/,/g, ""),
//                               );

//                               const approvedAmount = Number(value || 0);

//                               if (approvedAmount > expenseAmount) {
//                                 toastError(
//                                   `Approved amount cannot exceed expense amount (${expenseAmount})`,
//                                 );
//                                 return;
//                               }

//                               updateLine(rowIndex, "approved_amount", value);
//                             }}
//                           />
//                         </td>

//                         {/* REMARK */}
//                         <td className="edit-td-remarks">
//                           <input
//                             type="text"
//                             className="edit-remarks-input"
//                             placeholder="Enter remark"
//                             value={line.remarks || ""}
//                             onChange={(e) =>
//                               updateLine(rowIndex, "remarks", e.target.value)
//                             }
//                           />
//                         </td>

//                         {/* ATTACHMENT */}
//                         <td className="edit-td-attachment">
//                           {line.attachment_url ? (
//                             attachmentLoading[`${line.id}-view`] ? (
//                               <FaSpinner className="edit-spinner" size={16} />
//                             ) : (
//                               <Eye
//                                 size={18}
//                                 strokeWidth={1.5}
//                                 className="edit-attachment-icon"
//                                 onClick={() => handleAttachment(line, false)}
//                               />
//                             )
//                           ) : (
//                             <span className="edit-no-attachment">
//                               No attachment
//                             </span>
//                           )}
//                         </td>
//                       </tr>
//                     );
//                   })}

//                   {/* SUBTOTAL */}
//                   {(() => {
//                     const totalApproved = items.reduce(
//                       (sum, item) => sum + Number(item.approved_amount || 0),
//                       0,
//                     );
//                     return (
//                       <tr key={`${currency}-total`} className="edit-total-row">
//                         <td className="edit-total-label" colSpan="5">
//                           Subtotal ({currency})
//                         </td>
//                         <td className="edit-total-value">
//                           {formatAmount(total, currency)}
//                         </td>
//                         <td className="eedit-approved-total-value">
//                           {formatAmount(totalApproved, currency)}
//                         </td>

//                         <td className="edit-remarks-total-cell"></td>
//                         <td></td>
//                       </tr>
//                     );
//                   })()}
//                 </React.Fragment>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>

//       <div className="edit-bottom-actions-bar">
//         <button className="edit-cancel-button" onClick={handleCancel}>
//           Cancel
//         </button>
//         <button
//           className="edit-submit-button"
//           onClick={handleSubmit}
//           disabled={isSubmitting}
//         >
//           {isSubmitting
//             ? "Submitting..."
//             : expenseId
//               ? "Update Expense"
//               : "Submit Expense"}
//         </button>
//       </div>

//       {/* ====== PREVIEW OVERLAY ====== */}
//       {showPreview && (
//         <div
//           className="edit-preview-overlay"
//           onClick={() => setShowPreview(false)}
//         >
//           <div
//             className="edit-preview-box"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="edit-preview-close-btn"
//               onClick={() => setShowPreview(false)}
//             >
//               ✕
//             </button>
//             {previewUrl?.endsWith(".pdf") ? (
//               <iframe
//                 src={previewUrl}
//                 className="edit-preview-iframe"
//                 title="PDF"
//               />
//             ) : (
//               <img
//                 src={previewUrl}
//                 alt="preview"
//                 className="edit-preview-img"
//               />
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// MyEdit.jsx
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import useAuthStore from "../../services/authStore";
import { toastSuccess, toastError, toastWarning } from "../../services/toaster";
import "./MyEdit.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FaChevronDown, FaSpinner } from "react-icons/fa";
import { Eye, Paperclip } from "lucide-react";
const API_URL = process.env.REACT_APP_API_URL;

const emptyRow = {
  expense_type_id: "",
  description: "",
  date: "",
  amount: "",
  approved_amount: "",
  remarks: "",
  gl_code: "",
  currency: "",
  attachment: null,
};

export default function MyEdit() {
  // ================= STORE =================
  const token = useAuthStore((s) => s.token);
  const grade = useAuthStore((s) => s.grade);
  const companyId = useAuthStore((s) => s.companyId);
  const userId = useAuthStore((s) => s.user_id);
  const currency = useAuthStore((s) => s.currency);
  const employeeCode = useAuthStore((s) => s.employee_code);

  const navigate = useNavigate();
  const location = useLocation(); // ✅ Use location (not locationState)
  const isSendBackEdit = location.state?.sendBackEdit === true;
  const isApprovalEdit = location.state?.approvalEdit === true;

  console.log("========== MY EDIT MODE ==========");
  console.log("location.state:", location.state);
  console.log("isSendBackEdit:", isSendBackEdit);
  console.log("isApprovalEdit:", isApprovalEdit);
  console.log("==================================");
  const [attachmentLoading, setAttachmentLoading] = useState({});
  const [headerAttachment, setHeaderAttachment] = useState(null);
  const [headerAttachmentUrl, setHeaderAttachmentUrl] = useState(null);
  // ✅ Get where we came from
  const from = location.state?.from || "requests";
  const currentStatus = location.state?.currentStatus || "pending";

  // ================= REFS =================
  const tableRef = useRef(null);
  const dropdownRef = useRef(null);
  const fileInputRefs = useRef({});
  const headerFileInputRef = useRef(null);
  const selectRef = useRef(null);

  // ================= STATE =================
  const [loading, setLoading] = useState(false);
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [lines, setLines] = useState([{ ...emptyRow }]);
  const [purpose, setPurpose] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openCategoryRow, setOpenCategoryRow] = useState(null);
  const [categorySearch, setCategorySearch] = useState("");
  const [expenseId, setExpenseId] = useState(null);
  const [expenseCode, setExpenseCode] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const isEditableMode = isSendBackEdit;
  const currencyOptions = ["INR", "USD", "EUR", "AED"];
  const [gradeLimits, setGradeLimits] = useState([]);
  const handleAttachment = async (line, download = false) => {
    try {
      const fileName = line.attachment_url?.split("/").pop() || "attachment";
      const actionKey = `${line.id}-${download ? "download" : "view"}`;

      setAttachmentLoading((prev) => ({ ...prev, [actionKey]: true }));

      const res = await axios.get(`${API_URL}/expense/attachment`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          company_id: companyId,
          master_id: expenseId, // the expense ID

          expense_code: expenseCode, // you need to store this in state
          file_name: fileName,
          download: download,
        },
        responseType: "blob",
      });

      const fileURL = window.URL.createObjectURL(res.data);

      if (!download) {
        setPreviewUrl(fileURL);
        setShowPreview(true);
        return;
      }

      // download logic (optional)
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      toastError("Failed to load attachment");
    } finally {
      const actionKey = `${line.id}-${download ? "download" : "view"}`;
      setAttachmentLoading((prev) => ({ ...prev, [actionKey]: false }));
    }
  };

  const handlePreview = (url) => {
    setPreviewUrl(url);
    setShowPreview(true);
  };
  const sendNotification = async (notificationData) => {
    try {
      const { integrationToken, integrationBaseUrl } = useAuthStore.getState();

      if (!integrationToken) {
        console.error("Integration token missing");
        return;
      }

      const params = new URLSearchParams();

      params.append(
        "from_userid",
        notificationData.from_userid?.toString() || "",
      );
      params.append("to_userid", notificationData.to_userid?.toString() || "");
      params.append("message", notificationData.message || "");
      params.append("link", notificationData.link || "");
      params.append(
        "timestamp",
        notificationData.timestamp ||
          notificationData.timespan ||
          new Date().toLocaleString("sv-SE", {
            timeZone: "Asia/Kolkata",
          }),
      );

      const response = await axios.post(
        `${integrationBaseUrl}/api/notification_api`,
        params,
        {
          headers: {
            Authorization: `Bearer ${integrationToken}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      console.log("Notification sent", response.data);
    } catch (error) {
      console.error("Notification API failed", error);
      throw error;
    }
  };
  // ================= CLICK OUTSIDE HANDLER =================
  useEffect(() => {
    const handleClickOutside = () => {
      setOpenCategoryRow(null);
      setCategorySearch("");
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // ================= FETCH EXPENSE TYPES =================
  useEffect(() => {
    if (!companyId || !token) return;

    fetch(`${API_URL}/expense-type/${companyId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : data?.data || [];
        const activeExpenseTypes = list.filter(
          (item) => Number(item.isactive) === 1,
        );
        setExpenseTypes(activeExpenseTypes);
      })
      .catch(console.error);
  }, [companyId, token]);

  // ================= LOAD EXPENSE DATA FOR EDIT =================
  useEffect(() => {
    console.log("📍 Location state:", location.state);

    if (location.state?.expenseData) {
      const expenseData = location.state.expenseData;
      console.log("📦 Expense data received:", expenseData);
      console.log(
        "APPROVED AMOUNTS:",
        expenseData.expense_lines?.map((line) => ({
          id: line.id,
          total_amount: line.total_amount,
          approved_amount: line.approved_amount,
        })),
      );
      setExpenseId(expenseData.id);
      setExpenseCode(expenseData.expense_id);
      setPurpose(expenseData.purpose || "");
      setDescription(expenseData.description || "");
      setHeaderAttachmentUrl(expenseData.attachment || null);
      setHeaderAttachment(null);
      // Map expense lines
      if (expenseData.expense_lines && expenseData.expense_lines.length > 0) {
        const mappedLines = expenseData.expense_lines.map((line) => ({
          id: line.id,
          expense_type_id: line.expense_type_id,
          description: line.description || "",
          date: line.date || "",

          // Always load the actual expense amount.
          amount: line.total_amount ?? "",

          // Approval edit: initially show Expense Amount if no approved amount exists.
          // Send-back edit: show existing Approved Amount, otherwise 0.

          approved_amount:
            line.approved_amount && Number(line.approved_amount) > 0
              ? line.approved_amount
              : line.total_amount,

          remarks: line.remarks || "",
          gl_code: line.gl_code || "",
          currency: line.currency || "INR",
          attachment: null,
          attachment_url: line.attachment,
          attachment_name: line.attachment
            ? line.attachment.split("/").pop()
            : "",
        }));

        setLines(mappedLines);

        console.log("🔍 APPROVED AMOUNT CHECK:", {
          expenseId: expenseData.id,
          expenseLines: expenseData.expense_lines,
          approvedAmounts: expenseData.expense_lines?.map((line) => ({
            lineId: line.id,
            total_amount: line.total_amount,
            approved_amount: line.approved_amount,
            approved_amount_type: typeof line.approved_amount,
          })),
        });
        console.log("📝 Mapped lines:", mappedLines);

        setLines(mappedLines);
      } else {
        setLines([{ ...emptyRow }]);
      }
    } else {
      console.warn("⚠️ No expense data found in location.state");
      setLines([{ ...emptyRow }]);
    }
  }, [location.state, isApprovalEdit]);
  // ================= HELPERS =================
  const addAmounts = (amounts = []) => {
    let totalPaise = 0;
    amounts.forEach((value) => {
      const clean = String(value || "0").replace(/,/g, "");
      const [rupees = "0", decimals = "00"] = clean.split(".");
      const decimalValue = (decimals + "00").slice(0, 2);
      totalPaise += Number(rupees) * 100 + Number(decimalValue);
    });
    return (totalPaise / 100).toFixed(2);
  };
  useEffect(() => {
    if (!companyId || !token || !grade) return;

    const fetchGradeLimits = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/expense-grade-limit/${companyId}`,
          {
            params: {
              grades: grade,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setGradeLimits(res.data || []);
      } catch (error) {
        console.error("Failed to fetch grade limits:", error);
        setGradeLimits([]);
      }
    };

    fetchGradeLimits();
  }, [companyId, token, grade]);

  const formatIndianNumber = (value) => {
    if (!value) return "";
    const [integerPart, decimalPart] = String(value).split(".");
    const lastThree = integerPart.slice(-3);
    const otherNumbers = integerPart.slice(0, -3);
    const formattedInteger =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      (otherNumbers ? "," : "") +
      lastThree;
    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };

  const formatInternationalNumber = (value) => {
    if (!value) return "";
    const [integerPart, decimalPart] = String(value).split(".");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };

  const formatAmount = (amount, currencyCode = "INR") => {
    const value = String(amount || "0").replace(/,/g, "");
    if (currencyCode === "INR") {
      return formatIndianNumber(Number(value).toFixed(2));
    }
    return formatInternationalNumber(Number(value).toFixed(2));
  };

  const formatInputAmount = (amount, currency) => {
    if (amount === "" || amount === null || amount === undefined) {
      return "";
    }

    const numericAmount = Number(String(amount).replace(/,/g, ""));

    if (Number.isNaN(numericAmount)) {
      return "";
    }

    return numericAmount.toLocaleString(
      currency === "INR" ? "en-IN" : "en-US",
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      },
    );
  };

  const getFileExtension = (filename) =>
    filename.split(".").pop().toLowerCase();

  const allowed_extensions = ["png", "jpg", "jpeg", "pdf", "xlsx", "xls"];

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result.split(",")[1];
        resolve({
          filename: file.name,
          base64: base64,
        });
      };
      reader.onerror = (err) => reject(err);
    });
  };

  // ================= GROUP BY CURRENCY =================
  const groupedByCurrency = lines.reduce((acc, line, originalIndex) => {
    const cur = line.currency || "INR";
    if (!acc[cur]) acc[cur] = [];
    acc[cur].push({ ...line, originalIndex });
    return acc;
  }, {});

  // ================= UPDATE LINE =================
  const updateLine = (i, field, value) => {
    setLines((prev) =>
      prev.map((l, index) => (index === i ? { ...l, [field]: value } : l)),
    );
  };
  // const getGradeLimit = (line) => {
  //   const expenseType = gradeLimits.find(
  //     (item) => Number(item.expensetypeid) === Number(line.expense_type_id),
  //   );

  //   if (!expenseType?.limits?.length) {
  //     return null;
  //   }

  //   const gradeLimit = expenseType.limits.find(
  //     (limit) =>
  //       String(limit.expensegradecode).toLowerCase() ===
  //       String(grade).toLowerCase(),
  //   );

  //   if (!gradeLimit || gradeLimit.isconfigured === false) {
  //     return null;
  //   }

  //   return Number(gradeLimit.limitamount);
  // };

  const getGradeLimit = (line) => {
    const expenseType = gradeLimits.find(
      (item) => Number(item.expensetypeid) === Number(line.expense_type_id),
    );

    if (!expenseType) return null;

    const gradeLimit = expenseType.limits?.find(
      (limit) => String(limit.expensegradecode).trim() === String(grade).trim(),
    );

    if (
      !gradeLimit ||
      gradeLimit.limitamount === null ||
      gradeLimit.limitamount === undefined ||
      String(gradeLimit.limitamount).trim() === ""
    ) {
      return null;
    }

    const amount = Number(gradeLimit.limitamount);

    return Number.isFinite(amount) ? amount : null;
  };

  // ================= VALIDATION =================
  const validateForm = () => {
    if (!purpose.trim()) {
      toastWarning("Please enter purpose");
      return false;
    }
    if (lines.length === 0) {
      toastWarning("Please add at least one expense line");
      return false;
    }
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      if (!line.expense_type_id) {
        toastError(`Row ${i + 1}: Please select a category`);
        return false;
      }
      if (!line.description) {
        toastWarning(`Row ${i + 1}: Please enter a description`);
        return false;
      }
      if (!line.amount || Number(line.amount) <= 0) {
        toastWarning(`Row ${i + 1}: Please enter a valid amount`);
        return false;
      }

      const expenseAmount = parseFloat(line.amount || 0);
      const approvedAmount = parseFloat(line.approved_amount || 0);

      if (
        isApprovalEdit &&
        approvedAmount < expenseAmount &&
        !String(line.remarks || "").trim()
      ) {
        toastError(`Row ${i + 1}: Approved Remark is required`);
        return false;
      }

      if (!line.date) {
        toastWarning(`Row ${i + 1}: Please select a date`);
        return false;
      }
    }
    return true;
  };

  console.log("expenseId =", expenseId);
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const convertedAttachments = await Promise.all(
        lines.map(async (line) => {
          if (!line.attachment) return null;
          return await fileToBase64(line.attachment);
        }),
      );

      let response;

      if (expenseId && isSendBackEdit) {
        // ============================================================
        // SEND BACK EDIT FLOW
        // PUT /expense/{company_id}/edit/{master_id}
        // ============================================================

        let headerAttachmentPayload = null;

        if (headerAttachment) {
          headerAttachmentPayload = await fileToBase64(headerAttachment);
        }

        const payload = {
          purpose: purpose,
          description: description,

          // Required master-level fields
          currency: currency || lines[0]?.currency || "INR",

          total_amount: Number(addAmounts(lines.map((line) => line.amount))),

          // Header attachment
          attachment: headerAttachmentPayload,

          expense_lines: lines.map((line, index) => ({
            id: Number(line.id),
            expense_type_id: Number(line.expense_type_id),
            description: line.description,
            date: line.date,
            currency: line.currency,
            total_amount: Number(addAmounts([line.amount])),
            remarks: line.remarks || "",
            attachment: convertedAttachments[index] || null,
          })),
        };

        response = await axios.put(
          `${API_URL}/expense/${companyId}/edit/${expenseId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        // Send notification only after the update succeeds.
        if (response?.data?.status === true) {
          const notificationData = response?.data?.data?.notification;

          if (notificationData) {
            try {
              await sendNotification({
                ...notificationData,
                timestamp:
                  notificationData.timestamp ?? notificationData.timespan,
              });
            } catch (notificationError) {
              // Notification failure should not undo a successful expense update.
              console.error(
                "Failed to send expense update notification:",
                notificationError,
              );
            }
          }

          toastSuccess(
            response?.data?.message || "Expense updated successfully.",
          );
        }
      } else if (expenseId && isApprovalEdit) {
        // ============================================================
        // EXISTING APPROVED AMOUNT LOGIC
        // DO NOT CHANGE THIS
        // ============================================================

        const approvedPayload = {
          expense_id: Number(expenseId),
          user_id: Number(userId),
          expense_lines: lines.map((line) => ({
            id: Number(line.id),
            expense_type_id: Number(line.expense_type_id),
            currency: line.currency,
            approved_amount: Number(
              String(line.approved_amount || 0).replace(/,/g, ""),
            ),
            remarks: line.remarks || "",
          })),
        };

        response = await axios.put(
          `${API_URL}/expense/approved-amount`,
          approvedPayload,
          {
            params: {
              company_id: companyId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
      } else {
        // ============================================================
        // EXISTING CREATE LOGIC
        // DO NOT CHANGE
        // ============================================================

        const payload = {
          company_id: String(companyId),
          user_id: String(userId),
          employee_code: employeeCode || String(userId),
          purpose: purpose,
          currency: currency || "INR",
          total_amount: Number(addAmounts(lines.map((l) => l.amount))),
          description: description,
          attachment: null,

          expense_lines: lines.map((l, index) => ({
            expense_type_id: Number(l.expense_type_id),
            description: l.description,
            date: l.date,
            currency: l.currency,
            total_amount: Number(addAmounts([l.amount])),
            attachment: convertedAttachments[index] || null,
            approved_amount: l.approved_amount ? Number(l.approved_amount) : 0,
            remarks: l.remarks || "",
          })),
        };

        response = await axios.post(
          `${API_URL}/expense/${companyId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        toastSuccess("Expense created successfully!");
      }

      const expenseIdToPass = expenseId || response?.data?.data?.id;

      // Navigate back to where we came from
      if (from === "authorisations") {
        navigate(`/authorisations/${currentStatus}`, {
          state: {
            selectedExpenseId: expenseIdToPass,
          },
        });
      } else {
        navigate(`/requests/${currentStatus}`, {
          state: {
            selectedExpenseId: expenseIdToPass,
          },
        });
      }
    } catch (error) {
      console.error("❌ Error:", error);

      if (error.response) {
        console.error("Response data:", error.response.data);

        toastError(
          error.response.data?.message ||
            error.response.data?.error ||
            `Server error: ${error.response.status}`,
        );
      } else if (error.request) {
        toastError("Network error. Please check your connection.");
      } else {
        toastError(error.message || "Something went wrong");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // ================= HANDLE LINE ATTACHMENT =================

  const handleLineAttachmentChange = (rowIndex, file) => {
    setLines((prev) =>
      prev.map((line, index) =>
        index === rowIndex
          ? {
              ...line,
              attachment: file,
              attachment_name: file ? file.name : "",
            }
          : line,
      ),
    );
  }; // ================= HANDLE CANCEL =================
  const handleCancel = () => {
    // ✅ Navigate back to where we came from
    if (from === "authorisations") {
      navigate(`/authorisations/${currentStatus}`);
    } else {
      navigate(`/requests/${currentStatus}`);
    }
  };

  // ================= LOADING STATE =================
  if (loading) {
    return (
      <div className="center-loader">
        <FaSpinner className="spinner" />
        <div>Loading...</div>
      </div>
    );
  }

  // ================= RENDER =================
  return (
    <div className="edit-main-wrapper">
      <div className="edit-top-fixed">
        <div className="edit-purpose-wrapper">
          <label className="edit-purpose-label">
            Purpose <span className="edit-required-star">*</span>
          </label>

          <input
            type="text"
            className="edit-purpose-input"
            value={purpose}
            disabled={!isSendBackEdit}
            onChange={(e) => setPurpose(e.target.value)}
          />
        </div>

        <div className="edit-header-fields-row">
          <div className="edit-description-wrapper">
            <label className="edit-purpose-label">Description</label>
            <input
              type="text"
              className="edit-purpose-input"
              value={description}
              disabled={!isSendBackEdit}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description"
            />
          </div>

          <div className="edit-description-wrapper">
            <label className="edit-purpose-label">Header Attachment</label>

            <div className="edit-header-attachment-wrapper">
              <input
                type="file"
                id="header-attachment"
                ref={headerFileInputRef}
                className="edit-hidden-file-input"
                accept=".png,.jpg,.jpeg,.pdf,.xlsx,.xls"
                onChange={(e) => {
                  const file = e.target.files?.[0] || null;

                  if (!file) return;

                  setHeaderAttachment(file);
                  setHeaderAttachmentUrl(null);

                  if (headerFileInputRef.current) {
                    headerFileInputRef.current.value = "";
                  }
                }}
              />

              {headerAttachmentUrl && !headerAttachment ? (
                <>
                  <span className="edit-attachment-file-name">
                    {headerAttachmentUrl.split("/").pop()}
                  </span>

                  <button
                    type="button"
                    className="edit-attachment-view-btn"
                    onClick={() =>
                      handleAttachment(
                        {
                          id: "header",
                          attachment_url: headerAttachmentUrl,
                        },
                        false,
                      )
                    }
                    title="View attachment"
                  >
                    <Eye size={17} strokeWidth={1.7} />
                  </button>

                  {isSendBackEdit && (
                    <label
                      htmlFor="header-attachment"
                      className="edit-attachment-choose-btn"
                    >
                      Choose File
                    </label>
                  )}
                </>
              ) : headerAttachment ? (
                <>
                  <span className="edit-attachment-file-name">
                    {headerAttachment.name}
                  </span>

                  <label
                    htmlFor="header-attachment"
                    className="edit-attachment-choose-btn"
                  >
                    Change File
                  </label>
                </>
              ) : isSendBackEdit ? (
                <label
                  htmlFor="header-attachment"
                  className="edit-attachment-choose-btn"
                >
                  Choose File
                </label>
              ) : (
                <span className="edit-no-attachment">No attachment</span>
              )}
            </div>
          </div>
        </div>

        <div className="edit-line-header-wrapper">
          <h3 className="edit-line-title">Expense Line Items</h3>
        </div>
      </div>

      <div className="edit-table-scroll" ref={tableRef}>
        <table className="edit-data-table">
          <thead>
            <tr>
              <th className="edit-th-serial">#</th>
              <th className="edit-th-category">Expense Category</th>
              <th className="edit-th-currency">Currency</th>
              <th className="edit-th-description">Expense Description</th>
              <th className="edit-th-date">Expense Date</th>
              <th className="edit-th-amount">Expense Amount</th>
              <th className="edit-th-approved-amount">Approved Amount</th>
              <th className="edit-th-remarks">Aprroved Remark</th>
              <th className="edit-th-attachment">Attachment</th>
            </tr>
          </thead>

          <tbody>
            {Object.entries(groupedByCurrency).map(([currency, items]) => {
              const total = addAmounts(items.map((item) => item.amount));
              return (
                <React.Fragment key={currency}>
                  {items.map((line) => {
                    const rowIndex = line.originalIndex;
                    return (
                      <tr key={rowIndex} className="edit-data-row">
                        <td className="edit-td-serial">{rowIndex + 1}</td>

                        {/* CATEGORY */}
                        <td
                          className="edit-td-category"
                          style={{ position: "relative" }}
                        >
                          <div
                            className="edit-custom-select-box"
                            onClick={(e) => {
                              if (!isSendBackEdit && !isApprovalEdit) return;

                              e.stopPropagation();

                              setOpenCategoryRow(
                                openCategoryRow === rowIndex ? null : rowIndex,
                              );
                            }}
                          >
                            <span className="edit-selected-category-text">
                              {expenseTypes.find(
                                (t) =>
                                  String(t.id) === String(line.expense_type_id),
                              )?.expensetypename || "Select Expense Category"}
                            </span>
                            <FaChevronDown
                              className={`edit-dropdown-arrow ${
                                openCategoryRow === rowIndex
                                  ? "edit-rotate"
                                  : ""
                              }`}
                            />
                          </div>

                          {openCategoryRow === rowIndex && (
                            <div
                              ref={dropdownRef}
                              className="edit-custom-dropdown"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className="edit-dropdown-search-wrapper">
                                <input
                                  autoFocus
                                  type="text"
                                  className="edit-dropdown-search"
                                  onClick={(e) => e.stopPropagation()}
                                  placeholder="Search expense category..."
                                  value={categorySearch}
                                  onChange={(e) =>
                                    setCategorySearch(e.target.value)
                                  }
                                />
                              </div>
                              <div className="edit-dropdown-list">
                                {expenseTypes
                                  .filter((item) =>
                                    item.expensetypename
                                      .toLowerCase()
                                      .includes(categorySearch.toLowerCase()),
                                  )
                                  .map((item) => (
                                    <div
                                      key={item.id}
                                      className={`edit-dropdown-item ${
                                        String(line.expense_type_id) ===
                                        String(item.id)
                                          ? "edit-selected"
                                          : ""
                                      }`}
                                      onClick={() => {
                                        updateLine(
                                          rowIndex,
                                          "expense_type_id",
                                          item.id,
                                        );
                                        updateLine(
                                          rowIndex,
                                          "gl_code",
                                          item.glcode || "",
                                        );
                                        updateLine(
                                          rowIndex,
                                          "currency",
                                          item.currency || "INR",
                                        );
                                        setOpenCategoryRow(null);
                                        setCategorySearch("");
                                      }}
                                    >
                                      {item.expensetypename}
                                    </div>
                                  ))}
                              </div>
                            </div>
                          )}
                        </td>

                        {/* CURRENCY */}
                        <td className="edit-td-currency">
                          <select
                            className="edit-currency-select"
                            value={line.currency || ""}
                            disabled={!isSendBackEdit && !isApprovalEdit}
                            onChange={(e) =>
                              updateLine(rowIndex, "currency", e.target.value)
                            }
                          >
                            {currencyOptions.map((cur) => (
                              <option key={cur} value={cur}>
                                {cur}
                              </option>
                            ))}
                          </select>
                        </td>

                        {/* DESCRIPTION */}
                        <td className="edit-td-description">
                          <input
                            className="edit-description-input"
                            value={line.description}
                            placeholder="Enter expense description"
                            onChange={(e) =>
                              updateLine(
                                rowIndex,
                                "description",
                                e.target.value,
                              )
                            }
                          />
                        </td>

                        {/* DATE */}
                        <td className="edit-td-date">
                          <input
                            className="edit-date-input"
                            type="date"
                            value={line.date}
                            disabled={!isSendBackEdit}
                            onChange={(e) =>
                              updateLine(rowIndex, "date", e.target.value)
                            }
                          />
                        </td>

                        {/* EXPENSE AMOUNT */}

                        {/* EXPENSE AMOUNT */}
                        <td className="edit-td-amount">
                          <input
                            type="text"
                            inputMode="decimal"
                            disabled={!isSendBackEdit}
                            placeholder="0.00"
                            className="edit-amount-input"
                            value={line.amount ?? ""}
                            onChange={(e) => {
                              const rawValue = e.target.value.replace(/,/g, "");

                              if (!/^\d*\.?\d{0,2}$/.test(rawValue)) return;

                              if (rawValue === "") {
                                updateLine(rowIndex, "amount", "");
                                return;
                              }

                              const enteredAmount = Number(rawValue);
                              const gradeLimit = getGradeLimit(line);

                              if (
                                gradeLimit !== null &&
                                enteredAmount > gradeLimit
                              ) {
                                toastWarning(
                                  `You cannot enter more than ${formatAmount(
                                    gradeLimit,
                                    line.currency,
                                  )} ${line.currency}.`,
                                );
                                return;
                              }

                              updateLine(rowIndex, "amount", rawValue);
                            }}
                            onBlur={() => {
                              const value = line.amount;

                              if (
                                value !== "" &&
                                value !== null &&
                                value !== undefined
                              ) {
                                updateLine(
                                  rowIndex,
                                  "amount",
                                  Number(
                                    String(value).replace(/,/g, ""),
                                  ).toFixed(2),
                                );
                              }
                            }}
                          />
                        </td>

                        {/* APPROVED AMOUNT */}
                        <td className="edit-td-approved-amount">
                          {/* <input
                            type="text"
                            inputMode="decimal"
                            className="edit-approved-amount-input"
                            value={formatInputAmount(
                              line.approved_amount || "",
                              line.currency,
                            )}
                            onChange={(e) => {
                              const value = e.target.value.replace(/,/g, "");

                              if (!/^\d*\.?\d{0,2}$/.test(value)) {
                                return;
                              }

                              const expenseAmount = Number(
                                String(line.amount || 0).replace(/,/g, ""),
                              );

                              const approvedAmount = Number(value || 0);

                              if (approvedAmount > expenseAmount) {
                                toastError(
                                  `Approved amount cannot exceed expense amount (${expenseAmount})`,
                                );
                                return;
                              }

                              updateLine(rowIndex, "approved_amount", value);
                            }}
                          /> */}
                          <input
                            type="text"
                            inputMode="decimal"
                            className="edit-approved-amount-input"
                            value={formatInputAmount(
                              line.approved_amount ?? "",
                              line.currency,
                            )}
                            disabled={!isApprovalEdit}
                            onChange={(e) => {
                              const value = e.target.value.replace(/,/g, "");

                              if (!/^\d*\.?\d{0,2}$/.test(value)) {
                                return;
                              }

                              const expenseAmount = Number(
                                String(line.amount || 0).replace(/,/g, ""),
                              );

                              const approvedAmount = Number(value || 0);

                              if (approvedAmount > expenseAmount) {
                                toastError(
                                  `Approved amount cannot exceed expense amount (${formatAmount(
                                    expenseAmount,
                                    line.currency,
                                  )})`,
                                );
                                return;
                              }

                              updateLine(rowIndex, "approved_amount", value);
                            }}
                          />
                        </td>

                        {/* REMARK */}
                        <td className="edit-td-remarks">
                          <input
                            type="text"
                            className="edit-remarks-input"
                            placeholder="Enter remark"
                            value={line.remarks || ""}
                            disabled={!isSendBackEdit && !isApprovalEdit}
                            onChange={(e) =>
                              updateLine(rowIndex, "remarks", e.target.value)
                            }
                          />
                        </td>

                        <td className="edit-td-attachment">
                          {isSendBackEdit ? (
                            <>
                              <input
                                type="file"
                                id={`attachment-${rowIndex}`}
                                ref={(el) => {
                                  fileInputRefs.current[rowIndex] = el;
                                }}
                                accept=".png,.jpg,.jpeg,.pdf,.xlsx,.xls"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  const file = e.target.files?.[0] || null;
                                  handleLineAttachmentChange(rowIndex, file);
                                }}
                              />

                              <div className="edit-attachment-wrapper">
                                {/* Choose / Change attachment */}
                                <label
                                  htmlFor={`attachment-${rowIndex}`}
                                  className="edit-attachment-icon"
                                  title={
                                    line.attachment
                                      ? "Change attachment"
                                      : "Choose attachment"
                                  }
                                >
                                  <Paperclip size={18} strokeWidth={1.7} />
                                </label>

                                {/* Attachment name */}
                                {line.attachment_name && (
                                  <span
                                    className="edit-attachment-name"
                                    title={line.attachment_name}
                                  >
                                    {line.attachment_name}
                                  </span>
                                )}

                                {/* Preview existing attachment */}
                                {line.attachment_url &&
                                  (attachmentLoading[`${line.id}-view`] ? (
                                    <FaSpinner
                                      className="edit-spinner"
                                      size={16}
                                    />
                                  ) : (
                                    <Eye
                                      size={22}
                                      strokeWidth={2}
                                      className="edit-attachment-eye"
                                      onClick={() =>
                                        handleAttachment(line, false)
                                      }
                                      title="Preview attachment"
                                    />
                                  ))}
                              </div>
                            </>
                          ) : line.attachment_url ? (
                            attachmentLoading[`${line.id}-view`] ? (
                              <FaSpinner className="edit-spinner" size={16} />
                            ) : (
                              <div className="edit-attachment-wrapper">
                                <span
                                  className="edit-attachment-name"
                                  title={line.attachment_name}
                                >
                                  {line.attachment_name || "Attachment"}
                                </span>

                                <Eye
                                  size={18}
                                  strokeWidth={1.7}
                                  className="edit-attachment-icon"
                                  onClick={() => handleAttachment(line, false)}
                                  title="Preview attachment"
                                />
                              </div>
                            )
                          ) : (
                            <span className="edit-no-attachment">
                              No attachment
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}

                  {/* SUBTOTAL */}
                  {(() => {
                    const totalApproved = items.reduce(
                      (sum, item) => sum + Number(item.approved_amount || 0),
                      0,
                    );
                    return (
                      <tr key={`${currency}-total`} className="edit-total-row">
                        <td className="edit-total-label" colSpan="5">
                          Subtotal ({currency})
                        </td>
                        <td className="edit-total-value">
                          {formatAmount(total, currency)}
                        </td>
                        <td className="eedit-approved-total-value">
                          {formatAmount(totalApproved, currency)}
                        </td>

                        <td className="edit-remarks-total-cell"></td>
                        <td></td>
                      </tr>
                    );
                  })()}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="edit-bottom-actions-bar">
        <button className="edit-cancel-button" onClick={handleCancel}>
          Cancel
        </button>
        <button
          className="edit-submit-button"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting
            ? "Submitting..."
            : expenseId
              ? "Update Expense"
              : "Submit Expense"}
        </button>
      </div>

      {/* ====== PREVIEW OVERLAY ====== */}
      {showPreview && (
        <div
          className="edit-preview-overlay"
          onClick={() => setShowPreview(false)}
        >
          <div
            className="edit-preview-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="edit-preview-close-btn"
              onClick={() => setShowPreview(false)}
            >
              ✕
            </button>
            {previewUrl?.endsWith(".pdf") ? (
              <iframe
                src={previewUrl}
                className="edit-preview-iframe"
                title="PDF"
              />
            ) : (
              <img
                src={previewUrl}
                alt="preview"
                className="edit-preview-img"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
